(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beneficios"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__rzvniBenefits) return;
    window.__rzvniBenefits = true;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function countUp(el) {
      var raw = (el.dataset.count || '').trim();
      var match = raw.match(/^(\d+)([.,]\d+)?$/);
      if (!match || reduced) return;
      var decimals = match[2] ? match[2].length - 1 : 0;
      var sep = match[2] ? match[2][0] : '.';
      var target = parseFloat(raw.replace(',', '.'));
      var start = null;
      var duration = 1400;
      function frame(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        var value = (target * eased).toFixed(decimals);
        el.textContent = decimals ? value.replace('.', sep) : value;
        if (p < 1) requestAnimationFrame(frame);
        else el.textContent = raw;
      }
      el.textContent = decimals ? (0).toFixed(decimals).replace('.', sep) : '0';
      requestAnimationFrame(frame);
    }

    function init(root) {
      var els = (root || document).querySelectorAll('.rzvni-bn [data-count]:not([data-counted])');
      if (!els.length) return;
      if (!('IntersectionObserver' in window) || document.documentElement.classList.contains('shopify-design-mode')) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.dataset.counted = 'true';
          countUp(e.target);
          io.unobserve(e.target);
        });
      }, { threshold: 0.6 });
      els.forEach(function (el) { io.observe(el); });
      if (window.RZVNI && window.RZVNI.initReveal) window.RZVNI.initReveal(root);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["encabezado"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('rzvni-header')) return;

    const DESKTOP = window.matchMedia('(min-width: 990px)');
    const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    class RzvniHeader extends HTMLElement {
      connectedCallback() {
        this.ac = new AbortController();
        const signal = this.ac.signal;

        this.bar = this.querySelector('[data-bar]');
        this.announce = this.querySelector('[data-announce]');
        this.drawer = this.querySelector('[data-drawer]');
        this.stickyMode = this.dataset.sticky;
        this.isTransparent = this.hasAttribute('data-transparent');
        this.lastY = window.scrollY;
        this.ticking = false;

        this.measure();
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.bar);
        if (this.announce) this.resizeObserver.observe(this.announce);

        window.addEventListener('scroll', () => this.onScroll(), { passive: true, signal });
        this.updateScrollState();

        this.setupAnnouncements(signal);
        this.setupDrawer(signal);
        this.setupLocalization(signal);
        this.setupIntegrations(signal);
      }

      disconnectedCallback() {
        this.ac?.abort();
        this.resizeObserver?.disconnect();
        clearInterval(this.announceTimer);
        document.documentElement.classList.remove('rzvni-scroll-lock');
      }

      /* ── Alturas compartidas con Horizon ── */
      measure() {
        const barHeight = this.bar.offsetHeight;
        const announceHeight = this.announce ? this.announce.offsetHeight : 0;
        const group = document.getElementById('header-group');
        let groupHeight = barHeight + announceHeight;

        if (group) {
          groupHeight = 0;
          for (const el of group.children) {
            if (el instanceof HTMLElement) groupHeight += el.offsetHeight;
          }
        }

        const style = document.body.style;
        style.setProperty('--rzvni-header-h', `${barHeight}px`);
        style.setProperty('--rzvni-announce-h', `${announceHeight}px`);
        style.setProperty('--header-height', `${barHeight}px`);
        style.setProperty(
          '--header-group-height',
          `${this.isTransparent ? Math.max(groupHeight - barHeight, 0) : groupHeight}px`
        );
      }

      /* ── Scroll ── */
      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.updateScrollState();
          this.ticking = false;
        });
      }

      updateScrollState() {
        const y = Math.max(window.scrollY, 0);
        const announceHeight = this.announce ? this.announce.offsetHeight : 0;
        this.toggleAttribute('data-scrolled', y > announceHeight + 8);

        if (this.stickyMode === 'scroll_up') {
          const delta = y - this.lastY;
          const threshold = this.bar.offsetHeight * 2 + announceHeight;
          const locOpen = this.querySelector('[data-loc-panel]:not([hidden])');

          if (y > threshold && delta > 4 && !locOpen) {
            this.setAttribute('data-hidden', '');
          } else if (delta < -4 || y <= threshold) {
            this.removeAttribute('data-hidden');
          }
        }

        this.lastY = y;
      }

      /* ── Anuncios rotativos ── */
      setupAnnouncements(signal) {
        if (!this.announce) return;
        const items = Array.from(this.announce.querySelectorAll('[data-announce-item]'));
        if (items.length < 2) return;

        const interval = Math.max(parseInt(this.announce.dataset.interval, 10) || 5000, 2000);
        let index = 0;
        let paused = false;

        const show = (next) => {
          items[index].classList.remove('is-active');
          items[index].setAttribute('aria-hidden', 'true');
          index = (next + items.length) % items.length;
          items[index].classList.add('is-active');
          items[index].removeAttribute('aria-hidden');
        };

        const start = () => {
          clearInterval(this.announceTimer);
          if (REDUCED.matches) return;
          this.announceTimer = setInterval(() => {
            if (!paused && !document.hidden) show(index + 1);
          }, interval);
        };

        this.announce.addEventListener('pointerenter', () => (paused = true), { signal });
        this.announce.addEventListener('pointerleave', () => (paused = false), { signal });
        this.announce.addEventListener('focusin', () => (paused = true), { signal });
        this.announce.addEventListener('focusout', () => (paused = false), { signal });

        /* Editor de temas: muestra el anuncio seleccionado */
        document.addEventListener(
          'shopify:block:select',
          (e) => {
            const i = items.findIndex((el) => el === e.target || el.contains(e.target));
            if (i > -1) {
              paused = true;
              show(i);
            }
          },
          { signal }
        );
        document.addEventListener('shopify:block:deselect', () => (paused = false), { signal });

        start();
      }

      /* ── Menú lateral ── */
      setupDrawer(signal) {
        if (!this.drawer) return;
        const openBtn = this.querySelector('[data-drawer-open]');
        const closeBtn = this.drawer.querySelector('[data-drawer-close]');

        openBtn?.addEventListener('click', () => this.openDrawer(), { signal });
        closeBtn?.addEventListener('click', () => this.closeDrawer(), { signal });

        /* Clic fuera del panel (sobre el fondo) */
        this.drawer.addEventListener(
          'click',
          (e) => {
            if (e.target === this.drawer) this.closeDrawer();
          },
          { signal }
        );

        this.drawer.addEventListener(
          'cancel',
          (e) => {
            e.preventDefault();
            this.closeDrawer();
          },
          { signal }
        );

        this.drawer.addEventListener(
          'close',
          () => {
            document.documentElement.classList.remove('rzvni-scroll-lock');
            this.drawer.removeAttribute('data-closing');
            openBtn?.focus({ preventScroll: true });
          },
          { signal }
        );
      }

      openDrawer() {
        if (this.drawer.open) return;
        this.drawer.showModal();
        document.documentElement.classList.add('rzvni-scroll-lock');
      }

      closeDrawer() {
        if (!this.drawer.open || this.drawer.hasAttribute('data-closing')) return;
        if (REDUCED.matches) {
          this.drawer.close();
          return;
        }
        this.drawer.setAttribute('data-closing', '');
        setTimeout(() => this.drawer.close(), 420);
      }

      /* ── País / idioma ── */
      setupLocalization(signal) {
        this.querySelectorAll('[data-loc-select]').forEach((select) => {
          select.addEventListener('change', () => select.form?.submit(), { signal });
        });

        const toggle = this.querySelector('[data-loc-toggle]');
        const panel = this.querySelector('[data-loc-panel]');
        if (!toggle || !panel) return;

        const setOpen = (open) => {
          panel.hidden = !open;
          toggle.setAttribute('aria-expanded', String(open));
        };

        toggle.addEventListener('click', () => setOpen(panel.hidden), { signal });

        document.addEventListener(
          'click',
          (e) => {
            if (!panel.hidden && !panel.contains(e.target) && !toggle.contains(e.target)) setOpen(false);
          },
          { signal }
        );

        document.addEventListener(
          'keydown',
          (e) => {
            if (e.key === 'Escape' && !panel.hidden) {
              setOpen(false);
              toggle.focus();
            }
          },
          { signal }
        );
      }

      /* ── Carrito lateral, buscador y contador de Horizon ── */
      setupIntegrations(signal) {
        this.querySelectorAll('[data-search-trigger]').forEach((link) => {
          link.addEventListener(
            'click',
            (e) => {
              const modal = document.getElementById('search-modal');
              if (!modal || typeof modal.showDialog !== 'function') return; // usa /search
              e.preventDefault();
              if (this.drawer?.open) this.drawer.close();
              modal.showDialog();
            },
            { signal }
          );
        });

        this.querySelector('[data-cart-drawer-trigger]')?.addEventListener(
          'click',
          (e) => {
            const cartDrawer = document.getElementById('cart-drawer');
            if (!cartDrawer || typeof cartDrawer.toggle !== 'function') return; // usa /cart
            e.preventDefault();
            cartDrawer.toggle();
          },
          { signal }
        );

        document.addEventListener(
          'shopify:cart:lines-update',
          (event) => {
            event.promise
              ?.then(({ cart, detail } = {}) => {
                const count = cart?.totalQuantity ?? detail?.itemCount;
                if (typeof count === 'number') this.setCartCount(count, true);
              })
              .catch(() => {});
          },
          { signal }
        );

        window.addEventListener(
          'pageshow',
          (e) => {
            if (!e.persisted) return;
            fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
              .then((r) => r.json())
              .then((c) => this.setCartCount(c.item_count, false))
              .catch(() => {});
          },
          { signal }
        );
      }

      setCartCount(count, animate) {
        const badge = this.querySelector('[data-cart-count]');
        if (!badge) return;
        const link = badge.closest('a');

        badge.textContent = count > 99 ? '99' : String(count);
        badge.hidden = count === 0;
        link?.setAttribute('aria-label', `Carrito, ${count} ${count === 1 ? 'artículo' : 'artículos'}`);

        if (animate && count > 0) {
          badge.classList.remove('is-bumped');
          void badge.offsetWidth;
          badge.classList.add('is-bumped');
        }
      }
    }

    customElements.define('rzvni-header', RzvniHeader);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
    var GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789/+—';

    function scrambleTo(el, target, done) {
      var from = el.textContent;
      var len = Math.max(from.length, target.length);
      var frame = 0;
      var total = 22;
      function tick() {
        var out = '';
        var progress = frame / total;
        for (var i = 0; i < len; i++) {
          var settled = i < Math.floor(progress * len);
          if (settled) {
            out += target[i] || '';
          } else if (i < target.length) {
            out += '<span class="is-glitch">' + GLYPHS[Math.floor(Math.random() * GLYPHS.length)] + '</span>';
          }
        }
        el.innerHTML = out;
        frame++;
        if (frame <= total) requestAnimationFrame(tick);
        else { el.textContent = target; if (done) done(); }
      }
      tick();
    }

    function initType(root) {
      (root || document).querySelectorAll('.rzvni-type').forEach(function (hero) {
        if (hero.dataset.ready) return;
        hero.dataset.ready = 'true';

        requestAnimationFrame(function () {
          requestAnimationFrame(function () { hero.classList.add('is-in'); });
        });

        /* Palabras rotativas */
        hero.querySelectorAll('[data-rotate]').forEach(function (el) {
          var words = el.dataset.rotate.split(',').map(function (w) { return w.trim(); }).filter(Boolean);
          if (words.length < 2 || REDUCED.matches) return;
          var index = 0;
          var interval = Math.max(parseInt(el.dataset.interval, 10) || 3000, 1500);
          setInterval(function () {
            if (document.hidden) return;
            index = (index + 1) % words.length;
            scrambleTo(el, words[index]);
          }, interval);
        });

        var reveals = hero.querySelectorAll('.rzvni-type__reveal');
        var objects = Array.prototype.slice.call(hero.querySelectorAll('[data-object]'));
        var hasHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

        function place(clientX, clientY) {
          reveals.forEach(function (r) {
            var rect = r.getBoundingClientRect();
            r.style.setProperty('--mx', clientX - rect.left + 'px');
            r.style.setProperty('--my', clientY - rect.top + 'px');
          });
        }

        if (hasHover && !REDUCED.matches) {
          var raf = null;
          hero.addEventListener('pointermove', function (e) {
            if (raf) return;
            raf = requestAnimationFrame(function () {
              raf = null;
              place(e.clientX, e.clientY);
              if (objects.length && hero.hasAttribute('data-float')) {
                var r = hero.getBoundingClientRect();
                var nx = (e.clientX - r.left) / r.width - 0.5;
                var ny = (e.clientY - r.top) / r.height - 0.5;
                objects.forEach(function (o) {
                  var depth = parseFloat(o.dataset.depth || '30');
                  var inner = o.querySelector('[data-object-inner]');
                  inner.style.setProperty('--px', nx * -depth + 'px');
                  inner.style.setProperty('--py', ny * -depth * 0.7 + 'px');
                });
              }
            });
          });
          hero.addEventListener('pointerleave', function () {
            reveals.forEach(function (r) { r.style.setProperty('--mx', '-999px'); });
            objects.forEach(function (o) {
              var inner = o.querySelector('[data-object-inner]');
              inner.style.setProperty('--px', '0px');
              inner.style.setProperty('--py', '0px');
            });
          });
        } else if (reveals.length && !REDUCED.matches) {
          /* Táctil: la luz recorre el texto sola */
          var t0 = performance.now();
          (function drift(now) {
            var t = (now - t0) / 1000;
            reveals.forEach(function (r, i) {
              var w = r.offsetWidth;
              var x = (Math.sin(t * 0.6 + i) * 0.5 + 0.5) * w;
              r.style.setProperty('--mx', x + 'px');
              r.style.setProperty('--my', r.offsetHeight * 0.5 + 'px');
            });
            requestAnimationFrame(drift);
          })(t0);
        }
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initType(); });
    else initType();
    document.addEventListener('shopify:section:load', function (e) { initType(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["producto"] && !Shopify.designMode) return;
  try {
    
(function () {
if (window.__rzvniProduct) return;
window.__rzvniProduct = true;
var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
var eventsModule = null;
function loadEvents() {
if (eventsModule) return Promise.resolve(eventsModule);
return import('@shopify/events')
.then(function (m) { eventsModule = m; return m; })
.catch(function () { return null; });
}
function pad(n) { return (n < 10 ? '0' : '') + n; }
function initProduct(section) {
if (!section || section.dataset.ready) return;
section.dataset.ready = 'true';
var track = section.querySelector('[data-track]');
var slides = Array.prototype.slice.call(section.querySelectorAll('[data-slide]'));
var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-thumb]'));
var prev = section.querySelector('[data-prev]');
var next = section.querySelector('[data-next]');
var current = section.querySelector('[data-current]');
var progress = section.querySelector('[data-progress]');
var index = 0;
function goTo(i, smooth) {
if (!track || !slides[i]) return;
track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
}
function onIndex(i) {
index = i;
thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
if (current) current.textContent = pad(i + 1);
if (progress) progress.parentElement.style.setProperty('--p', slides.length > 1 ? (i + 1) / slides.length : 1);
if (prev) prev.disabled = i === 0;
if (next) next.disabled = i === slides.length - 1;
slides.forEach(function (s, n) {
var v = s.querySelector('video');
if (!v) return;
if (n === i) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
});
}
if (track && slides.length) {
var ticking = false;
track.addEventListener('scroll', function () {
if (ticking) return;
ticking = true;
requestAnimationFrame(function () {
ticking = false;
var i = Math.round(track.scrollLeft / track.clientWidth);
if (i !== index) onIndex(Math.max(0, Math.min(slides.length - 1, i)));
});
}, { passive: true });
onIndex(0);
}
if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, index - 1)); });
if (next) next.addEventListener('click', function () { goTo(Math.min(slides.length - 1, index + 1)); });
thumbs.forEach(function (t) {
t.addEventListener('click', function () { goTo(parseInt(t.dataset.thumb, 10)); });
});
if (track) {
track.addEventListener('keydown', function (e) {
if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(slides.length - 1, index + 1)); }
if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(0, index - 1)); }
});
}
var jsonEl = section.querySelector('[data-product-json]');
if (!jsonEl) return;
var data;
try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
var variant = data.variants.find(function (v) { return v.id === data.current; }) || data.variants[0];
var inputs = Array.prototype.slice.call(section.querySelectorAll('[data-option-input]'));
var addBtn = section.querySelector('[data-add]');
var addLabel = section.querySelector('[data-add-label]');
var nowBtn = section.querySelector('[data-buy-now]');
var message = section.querySelector('[data-message]');
var qtyInput = section.querySelector('[data-qty-input]');
function selectedOptions() {
return Array.prototype.slice.call(section.querySelectorAll('.rzvni-pd__option')).map(function (fs) {
var checked = fs.querySelector('[data-option-input]:checked');
return checked ? checked.value : null;
});
}
function updateAvailability() {
var selected = selectedOptions();
section.querySelectorAll('.rzvni-pd__option').forEach(function (fs, oi) {
fs.querySelectorAll('[data-option-input]').forEach(function (input) {
var test = selected.slice();
test[oi] = input.value;
var match = data.variants.find(function (v) {
return v.options.every(function (o, k) { return o === test[k]; });
});
input.closest('.rzvni-pd__value').classList.toggle('is-unavailable', !match || !match.available);
});
});
}
function render() {
var priceEl = section.querySelector('[data-price]');
var compareEl = section.querySelector('[data-compare]');
var savingEl = section.querySelector('[data-saving]');
var savingVal = section.querySelector('[data-saving-value]');
var stickyPrice = section.querySelector('[data-sticky-price]');
if (!variant) {
if (addBtn) addBtn.disabled = true;
if (nowBtn) nowBtn.disabled = true;
if (addLabel) addLabel.textContent = data.labels.unavailable;
return;
}
if (priceEl) priceEl.textContent = variant.price;
if (stickyPrice) stickyPrice.textContent = variant.price;
if (compareEl) { compareEl.hidden = !variant.compare; if (variant.compare) compareEl.textContent = variant.compare; }
if (savingEl) { savingEl.hidden = !variant.saving; if (savingVal) savingVal.textContent = variant.saving; }
if (addBtn) addBtn.disabled = !variant.available;
if (nowBtn) nowBtn.disabled = !variant.available;
if (addLabel) addLabel.textContent = variant.available ? data.labels.add : data.labels.soldOut;
section.querySelectorAll('.rzvni-pd__option').forEach(function (fs) {
var checked = fs.querySelector('[data-option-input]:checked');
var label = fs.querySelector('[data-option-selected]');
if (checked && label) label.textContent = checked.value;
});
if (variant.media) {
var target = slides.findIndex(function (s) { return String(s.dataset.mediaId) === String(variant.media); });
if (target > -1) goTo(target);
}
if (window.history && window.history.replaceState && document.body.classList.contains('template-product')) {
var url = new URL(window.location.href);
url.searchParams.set('variant', variant.id);
window.history.replaceState({}, '', url.toString());
}
updateAvailability();
}
inputs.forEach(function (input) {
input.addEventListener('change', function () {
var selected = selectedOptions();
variant = data.variants.find(function (v) {
return v.options.every(function (o, k) { return o === selected[k]; });
});
render();
});
});
updateAvailability();
var offersEl = section.querySelector('[data-offers]');
var offerQty = 0;
var offerTotal = '';
function syncOffers() {
if (!offersEl) return;
var checked = offersEl.querySelector('[data-offer-input]:checked') || offersEl.querySelector('[data-offer-input]');
if (!checked) return;
if (!checked.checked) checked.checked = true;
var card = checked.closest('[data-offer]');
offerQty = parseInt(card.dataset.qty, 10) || 1;
offerTotal = card.dataset.total || '';
offersEl.querySelectorAll('[data-offer]').forEach(function (c) { c.classList.toggle('is-selected', c === card); });
offersEl.querySelectorAll('[data-color-row]').forEach(function (row) {
var n = parseInt(row.dataset.colorRow, 10);
row.hidden = n > offerQty;
var unit = row.querySelector('[data-color-unit]');
if (unit) unit.style.display = offerQty > 1 ? '' : 'none';
});
if (qtyInput) qtyInput.value = offerQty;
var stickyPrice = section.querySelector('[data-sticky-price]');
if (stickyPrice && offerTotal) stickyPrice.textContent = offerTotal;
}
function colorProps() {
if (!offersEl || !offersEl.querySelector('[data-colors]')) return null;
var picks = [];
offersEl.querySelectorAll('[data-color-row]').forEach(function (row) {
if (row.hidden) return;
var c = row.querySelector('[data-color-input]:checked');
if (c) picks.push(c.value);
});
if (!picks.length) return null;
var props = {};
props[offersEl.dataset.colorProp || 'Colores'] = picks.join(' + ');
return props;
}
if (offersEl) {
offersEl.addEventListener('change', syncOffers);
syncOffers();
}
function qty() {
if (offersEl && offerQty) return offerQty;
return Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1);
}
var minus = section.querySelector('[data-qty-minus]');
var plus = section.querySelector('[data-qty-plus]');
if (minus) minus.addEventListener('click', function () { offerQty = 0; qtyInput.value = Math.max(1, qty() - 1); });
if (plus) plus.addEventListener('click', function () { offerQty = 0; qtyInput.value = qty() + 1; });
function say(text, isError) {
if (!message) return;
message.textContent = text;
message.classList.toggle('is-error', !!isError);
clearTimeout(message._t);
message._t = setTimeout(function () { message.textContent = ''; }, 4000);
}
function addToCart(source, goCheckout) {
if (!variant || !variant.available) return;
var quantity = qty();
var props = colorProps();
var line = { id: variant.id, quantity: quantity };
if (props) line.properties = props;
if (addBtn) { addBtn.classList.add('is-loading'); addBtn.disabled = true; }
loadEvents().then(function (ev) {
var deferred = null;
if (!goCheckout && ev && ev.CartLinesUpdateEvent) {
deferred = ev.CartLinesUpdateEvent.createPromise();
source.dispatchEvent(new ev.CartLinesUpdateEvent({
action: 'add',
context: 'product',
lines: [{ merchandiseId: String(variant.id), quantity: quantity }],
promise: deferred.promise
}));
}
return fetch(root + 'cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify({ items: [line] })
})
.then(function (r) { return r.json(); })
.then(function (res) {
return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
var failed = !!res.status;
if (deferred) {
deferred.resolve({
cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
detail: {
items: cart.items,
source: 'rzvni-product',
sourceId: section.id,
itemCount: quantity,
productId: String(data.id),
didError: failed
}
});
}
if (failed) {
say(res.description || res.message || data.labels.error, true);
} else if (goCheckout) {
window.location.href = root + 'checkout';
} else {
say(data.labels.added);
if (!deferred) window.location.href = root + 'cart';
}
});
})
.catch(function () {
if (deferred) deferred.reject(new Error('add failed'));
say(data.labels.error, true);
});
}).finally(function () {
if (addBtn) { addBtn.classList.remove('is-loading'); addBtn.disabled = !variant.available; }
});
}
if (addBtn) addBtn.addEventListener('click', function () { addToCart(addBtn); });
var stickyAdd = section.querySelector('[data-sticky-add]');
if (stickyAdd) stickyAdd.addEventListener('click', function () { addToCart(stickyAdd); });
if (nowBtn) {
nowBtn.addEventListener('click', function () {
if (!variant || !variant.available) return;
if (colorProps()) { addToCart(nowBtn, true); return; }
window.location.href = root + 'cart/' + variant.id + ':' + qty() + '?checkout';
});
}
var sticky = section.querySelector('[data-sticky]');
if (sticky && addBtn && 'IntersectionObserver' in window) {
var io = new IntersectionObserver(function (entries) {
var e = entries[0];
var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
sticky.classList.toggle('is-visible', passed);
sticky.setAttribute('aria-hidden', String(!passed));
if (stickyAdd) stickyAdd.tabIndex = passed ? 0 : -1;
});
io.observe(addBtn);
}
}
function initAll(scope) {
(scope || document).querySelectorAll('.rzvni-pd').forEach(initProduct);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
else initAll();
document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
document.addEventListener('shopify:block:select', function (e) {
var section = e.target.closest && e.target.closest('.rzvni-pd');
if (!section) return;
var acc = e.target.closest('details');
if (acc) acc.open = true;
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rzvni-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__rzvniFaq) return;
    window.__rzvniFaq = true;
    /* Solo una pregunta abierta a la vez */
    document.addEventListener('toggle', function (e) {
      var item = e.target;
      if (!item.classList || !item.classList.contains('rzvni-faq__item') || !item.open) return;
      var list = item.closest('[data-faq]');
      if (!list) return;
      list.querySelectorAll('.rzvni-faq__item[open]').forEach(function (other) {
        if (other !== item) other.open = false;
      });
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rzvni-marca"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__rzvniBrand) return;
    window.__rzvniBrand = true;

    function init(root) {
      (root || document).querySelectorAll('[data-brand-video]:not([data-ready])').forEach(function (wrap) {
        wrap.setAttribute('data-ready', '');
        var video = wrap.querySelector('video');
        var btn = wrap.querySelector('[data-brand-sound]');
        if (!video) return;
        video.muted = true;
        video.setAttribute('playsinline', '');
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
              else video.pause();
            });
          }, { threshold: 0.35 }).observe(video);
        }
        if (btn) btn.addEventListener('click', function () {
          video.muted = !video.muted;
          btn.setAttribute('aria-pressed', String(!video.muted));
          btn.setAttribute('aria-label', video.muted ? 'Activar sonido' : 'Silenciar');
          if (!video.muted) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
        });
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rzvni-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-rz-vid]').forEach(function (sec) {
        if (sec.dataset.ready) return;
        sec.dataset.ready = '1';
        var video = sec.querySelector('video');
        var btn = sec.querySelector('[data-rz-sound]');
        if (!video) return;
        video.muted = true;
        video.setAttribute('muted', '');
        /* Solo se reproduce cuando está en pantalla (ahorra datos en celular) */
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
              else video.pause();
            });
          }, { threshold: 0.35 }).observe(video);
        }
        if (btn) {
          btn.addEventListener('click', function () {
            video.muted = !video.muted;
            btn.classList.toggle('is-unmuted', !video.muted);
            btn.setAttribute('aria-label', video.muted ? 'Activar sonido' : 'Silenciar');
            if (!video.muted) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
          });
        }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
